import Immutable from 'immutable';
// types
import ArtTypes from '~/constants/types/ArtTypes';
import CatalogTypes from '~/constants/types/CatalogTypes';
import DesignTypes from '~/constants/types/DesignTypes';
import FontTypes from '~/constants/types/FontTypes';
import UploadTypes from '~/constants/types/UploadTypes';
import NotificationTypes from '~/constants/types/NotificationTypes';
import * as NotificationConstants from '~/constants/NotificationConstants';

export function initialState() {
  return Immutable.Map({
    confirmation: null,
    notification: null
  });
}

function updateNotification(state, notification) {
  const defaultsMap = {
    ERROR: {title: 'Oops!'},
    SUCCESS: {title: 'Success!'},
    PROMPT: {title: ''}
  };
  const defaults = defaultsMap[notification.type] || {};
  return state
    .set('confirmation', null)
    .set('notification', {...defaults, ...notification});
}

export default function notification(state = initialState(), action) {
  switch (action.type) {
    case NotificationTypes.CONFIRM:
      return state.merge({
        confirmation: !!action.payload,
        notification: null
      });
    case NotificationTypes.DISMISS:
      return state.merge({
        confirmation: null,
        notification: null
      });
    case NotificationTypes.PROMPT:
      return updateNotification(state, {...action.payload, type: 'PROMPT'});
    case NotificationTypes.SUCCESS:
      return updateNotification(state, {...action.payload, type: 'SUCCESS'});
    case NotificationTypes.ERROR:
      return updateNotification(state, {...action.payload, type: 'ERROR'});
    case CatalogTypes.STYLE_LOAD_ERROR:
    case CatalogTypes.STYLES_ERROR: {
      if (action.payload?.ignoreLoadErrorNotification) return state;
      return updateNotification(state, {
        error: action.payload && action.payload.error,
        key: NotificationConstants.STYLE_LOAD_ERROR,
        type: 'ERROR'
      });
    }
    case DesignTypes.FETCH_FAILED:
      return updateNotification(state, {
        key: NotificationConstants.DESIGN_LOAD_ERROR,
        type: 'ERROR'
      });
    case DesignTypes.INVALID_UPLOAD:
      return updateNotification(state, {
        key: NotificationConstants.INVALID_UPLOAD,
        type: 'ERROR'
      });
    case UploadTypes.UPLOAD_FAILED:
    case UploadTypes.INVALID_FILE:
      return updateNotification(state, {key: action.payload, type: 'ERROR'});
    case ArtTypes.CATEGORY_FAILED:
    case ArtTypes.SEARCH_FAILED:
    case FontTypes.CATEGORY_FAILED:
      return updateNotification(state, {
        key: NotificationConstants.SERVICE_UNAVAILABLE,
        type: 'ERROR'
      });
    default:
      return state;
  }
}
